export default "__VITE_ASSET__BkzauTIx__"